// Toggleable preset chip rendered above an MRP table. Click to apply the
// preset filter; click again to remove it. The active style is intentionally
// strong (filled primary background) so the on/off state is obvious at a
// glance — the previous "Filtered to: [chip] [X]" pattern relied on an X
// icon to communicate dismissibility, which doubled as the only on/off
// affordance and made the chips harder to scan when several were active.
//
// `description` is surfaced as a native `title=` tooltip so a hover explains
// the underlying filter semantics (e.g. "Indemnity only" actually means
// "open claims with indemnity payments" because that's how the legacy
// status flags are scoped).
export function QuickFilterChip({
  label,
  description,
  active,
  onToggle,
}: {
  label: string;
  description: string;
  active: boolean;
  onToggle: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onToggle}
      aria-pressed={active}
      title={description}
      className={
        active
          ? "inline-flex items-center rounded-full border border-primary bg-primary px-2.5 py-0.5 font-medium text-primary-foreground text-xs focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:outline-none"
          : "inline-flex items-center rounded-full border border-border bg-transparent px-2.5 py-0.5 text-muted-foreground text-xs hover:border-muted-foreground/40 hover:bg-muted/60 hover:text-foreground focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none"
      }
    >
      {label}
    </button>
  );
}
